import { gql } from 'react-apollo';

export default gql`
  mutation validateOfferPassword($input: offerPasswordRequestInput!) {
    validateOfferPassword(input: $input)
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/offerPassword.js